import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import FundraisingEditTransactionForm from 'src/components/Forms/Fundraising/FundraisingEditTransactionForm';

const EditTransactionModal = () => (
  <ModalBase
    name={MODALS.editTransaction}
    size={MODALS_SIZE.medium}
    form={FORM.fundraisingTransaction}>
    <FundraisingEditTransactionForm />
  </ModalBase>
);

export default EditTransactionModal;
